import { indexData } from '@/mocks/home';

export default function IndexSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-secondary-100/80 text-secondary-700 text-xs font-semibold rounded-full mb-3">
            内容导航
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            频道索引
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            八大内容频道随心切换，找到你喜欢的影视类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                handleClick(item.href);
              }}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200 mb-3">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                {item.desc}
              </p>
              <span className="mt-2 text-xs font-semibold text-primary-500 bg-primary-50 group-hover:bg-primary-100 px-2.5 py-0.5 rounded-full transition-colors duration-200">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}